import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import IconOnlyButton from 'components/Buttons/IconOnlyButton';
import useWindowSize from 'utils/hooks/useWindowSize';

const QuickSearchSelectInput = ({
  fnSetIsResultListVisible,
  fnSetUserQuery,
  sUserQuery,
  bAutoFocus,
}) => {
  const { sScreenSize } = useWindowSize();
  const inputRef = useRef(null);
  const sPlaceholder =
    sScreenSize === 'small'
      ? 'Search Directory'
      : 'Search for people, employers, or locations';

  useEffect(() => {
    if (bAutoFocus) {
      inputRef.current?.focus();
    }
  }, [bAutoFocus]);

  return (
    <div className='quickSearchSelectInput__wrapper'>
      <label htmlFor='search-directory' className='hide_accessibly'>
        Search for people, employers, or locations
      </label>
      <input
        id='search-directory'
        type='text'
        name='search-directory'
        ref={inputRef}
        onChange={(event) => fnSetUserQuery(event.target.value)}
        autoComplete='off'
        value={sUserQuery}
        placeholder={sPlaceholder}
        className='quickSearchSelect__input t-paragraph--large'
      />
      {sUserQuery.length > 0 && (
        <IconOnlyButton
          sIcon='close'
          sAriaLabel='Clear search'
          className='quickSearchSelect__clearBtn'
          fnHandleClick={() => fnSetIsResultListVisible(false)}
          sFlavor='tertiary'
        />
      )}
    </div>
  );
};

QuickSearchSelectInput.propTypes = {
  fnSetIsResultListVisible: PropTypes.func.isRequired,
  fnSetUserQuery: PropTypes.func.isRequired,
  sUserQuery: PropTypes.string.isRequired,
  bAutoFocus: PropTypes.bool,
};

QuickSearchSelectInput.defaultProps = {
  bAutoFocus: false,
};

export default QuickSearchSelectInput;
